<template>
    <div>
        <Form
            class="width-80per"
            :model="formData"
            :rules="rules"
            ref="validForm"
            :labelWidth="100"
        >
            <FormItem label="账户" prop="accountId">
                <Select v-model="formData.accountId" clearable>
                    <Option
                        v-for="item in getNextOrgList"
                        :key="item.key"
                        :value="item.value"
                        >{{ item.label }}</Option
                    >
                </Select>
            </FormItem>
            <FormItem label="账期" prop="billDate">
                <DatePicker
                    class="width-100per"
                    type="daterange"
                    v-model="formData.billDate"
                    :options="dateOptions"
                    format="yyyy-mm-dd"
                    :confirm="false"
                    @on-change="handleDate"
                ></DatePicker>
            </FormItem>
        </Form>
        <!-- <vForm
            class="width-80per"
            :model="formData"
            :rules="rules"
            ref="validForm"
            :labelWidth="100"
        >
            <vFormItem label="账户" prop="accountId">
                <vSelect v-model="formData.accountId" clearable>
                    <vOption
                        v-for="item in getNextOrgList"
                        :key="item.key"
                        :value="item.value"
                        >{{ item.label }}</vOption
                    >
                </vSelect>
            </vFormItem>
            <vFormItem label="账期" prop="billDate">
                <vDatepicker
                    class="width-100per"
                    v-model="formData.billDate"
                    :options="dateOptions"
                    format="yyyy-MM-dd ~ yyyy-MM-dd"
                    @on-change="handleDate"
                ></vDatePicker>
            </vFormItem>
        </vForm> -->
        <div class="text-center margin-bottom-15">
            <Button class="margin-right-15" type="primary" @click="confirm"
                >确定</Button
            >
            <Button @click="cancel">取消</Button>
        </div>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
    data() {
        return {
            formData: {},
            resultData: {},
            required: {
                required: true,
                message: "该项不能为空，请填写",
            },
            dateOptions: {
                disabledDate(date) {
                    return date && date.valueOf() >= Date.now() - 86400000;
                },
            },
            rules: {
                accountId: [
                    {
                        required: true,
                        message: "该项不能为空，请填写",
                        // trigger: 'blur'
                    },
                ],
                billDate: [
                    {
                        required: true,
                        // required: true,
                        validator: (rule, value, callback) => {
                            console.log('校验', value)
                            if (!value || !value[0] || !value[1]) return callback(new Error('该项不能为空，请填写'));
                            else callback();
                        },
                        trigger: 'blur'
                        // // type: 'date',
                        // message: '该项不能为空，请填写',
                        // trigger: 'change'
                    }
                ],
            }
        };
    },
    methods: {
        handleDate (val) {
            return `${val[0]} ~ ${val[1]}`
        },
        async confirm() {
            console.log(this.formData)
            let flag = true;
            await this.$refs.validForm.validate((valid) => {
                console.log(valid)
                flag = valid;
            });
            if (!flag) return;
            console.log(this.formData);
            let billDateArr = this.formData.billDate.map(item => {
                return `${item.getFullYear()}-${item.getMonth() + 1}-${item.getDate()}`;
            });
            let billDate = billDateArr.join(' ~ ')
            console.log(billDate);
        },
        cancel() {
            this.$emit("on-close");
        },
    },
    computed: {
        ...mapGetters("dictionary", ["getNextOrgList"]),
        // rules() {
        //     return {
        //         accountId: [
        //             {
        //                 required: true,
        //                 message: "该项不能为空，请填写",
        //                 trigger: 'blur'
        //             },
        //         ],
        //         billDate: [
        //             {
        //                 required: true,
        //                 message: '该项不能为空，请填写',
        //                 trigger: 'blur'
        //             }
        //         ],
        //     };
        // },
    },
};
</script>

<style>
</style>